import { CircleArrowDown } from "lucide-react";
import { useEffect, useState } from "react";
import { fechAllPresse } from "../../API/Presse/presseService";
import icon from "../../images/icons/7.png";
import icon2 from "../../images/icons/8.png";
const PresseCommunique = () => {
  const [presse, setPresses] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalCount, setTotalCount] = useState<number>(0);
  const fetchData = async () => {
    const response = await fechAllPresse(currentPage, "Communiquées");
    if (response) {
      const { data, totalPages, totalCount } = response;
      setPresses(data);
      setTotalPages(totalPages);
      setTotalCount(totalCount);
    }
  };
  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const openFile = (file: any) => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/press/${encodeURIComponent(file)}`;

    window.open(fileUrl, "_blank");
  };

  const downloadFile = (file: string) => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/press/${encodeURIComponent(file)}`;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = file;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <section className="p-32 text-center bg-bg_aquavesc bg-blend-overlay ">
        <div className="flex items-center justify-center space-x-5">
          {/* <CalendarClock className="w-16 h-16 mr-5 text-aquaFoncé" /> */}
          <img src={icon} alt="" />
          <div className="font-bold text-center text-black text-7xl">
            Communiqués de presse
          </div>
        </div>
      </section>

      <div className="container mx-auto mt-20 mb-20 md:px-72 sm:px-72">
        <div className="flex flex-col space-y-8">
          {" "}
          {/* Vertical layout with spacing */}
          {presse.map((item) => (
            <div
              key={item.id}
              className="flex flex-row items-start gap-6 p-4 hover:bg-gray-50"
            >
              {/* Icon */}
              <div className="flex-shrink-0 w-12">
                <img src={icon2} alt="Press icon" />
              </div>

              {/* Text Content */}
              <div className="flex-1">
                <h3
                  className="mb-2 text-lg font-bold text-primary hover:cursor-pointer"
                  onClick={() => openFile(item.file)}
                >
                  {item.title}
                </h3>
                <p className="mb-2 text-gray-600">
                  {item.description && (
                    <div
                      className="w-full "
                      dangerouslySetInnerHTML={{
                        __html:
                          item.description
                            .substring(0, 80)
                            .replace(/<\/?strong>/g, "") +
                          (item.description.length > 80 ? "..." : ""),
                      }}
                    />
                  )}
                </p>
                <p className="text-sm text-primary">{"pdf, 230.79 Ko"}</p>
              </div>

              {/* Download Icon */}
              <div className="flex-shrink-0 w-12">
                <CircleArrowDown
                  className="w-8 h-8 text-primary hover:cursor-pointer"
                  onClick={() => downloadFile(item.file)}
                />
              </div>
            </div>
          ))}
          {totalPages > 1 && (
            <div className="flex justify-center mt-6 space-x-2">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                className={`px-4 py-2 rounded ${
                  currentPage === 1
                    ? "bg-gray-300"
                    : "bg-primary text-white hover:bg-primary-dark"
                }`}
              >
                Précédent
              </button>
              <span className="px-4 py-2 border rounded">
                {currentPage} / {totalPages}
              </span>
              <button
                disabled={currentPage === totalPages}
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                className={`px-4 py-2 rounded ${
                  currentPage === totalPages
                    ? "bg-gray-300"
                    : "bg-primary text-white hover:bg-primary-dark"
                }`}
              >
                Suivant
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PresseCommunique;
